export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-safari-5.d50446c5.svg";